import buttonClose from '@assets/button-close.svg';
import { ModalType } from '@data/types';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

interface Props extends ModalType {
  message?: string;
}

const ModalText: React.FC<Props> = ({
  setDisplayModal = () => {},
  displayModal,
  message = '',
}) => {
  const [isFadingIn, setIsFadingIn] = useState<boolean>(false);

  useEffect(() => {
    if (displayModal) {
      setTimeout(() => setIsFadingIn(true), 50);
    } else {
      setIsFadingIn(false);
    }
  }, [displayModal]);

  return (
    <div
      id="modal"
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        className={classNames(
          'bg-white rounded-lg overflow-hidden shadow-lg max-w-innerGrid w-full flex justify-center flex-col transition-opacity duration-200 ease-in',
          {
            'opacity-100': isFadingIn,
            'opacity-0': !isFadingIn,
          }
        )}
      >
        <div className="flex mb-auto">
          <button
            className="ml-auto p-4 pb-0 hover:opacity-50"
            onClick={() => setDisplayModal(!displayModal)}
          >
            <img src={buttonClose} alt="close" />
          </button>
        </div>

        <div className="mb-auto">
          <div className="bg-gray-100 px-8 pt-4 pb-8">
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalText;
